import renderPlansCount from 'sites/enroll.pivothealth.com/census/controller/renderPlansCount'
import urlParamsToObject from '@hc-frontend/shared-assets/src/js/utils/url/urlParamsToObject'
import toUrlParams from '@hc-frontend/shared-assets/src/js/utils/url/toUrlParams'
import executeWhenFinishToRender from 'core/renders/executeWhenFinishToRender'
import isSalesCenterSubDomain from 'utils/pivot/isSalesCenterSubDomain'
import getCoverageDuration from 'core/services/getCoverageDuration'
import initializerControllers from './initializerControllers'
import getFiltersFromUrl from 'core/DOM/getFiltersFromUrl'
import addEventListener from 'utils/DOM/addEventListener'
import ifNotTrueExecute from 'utils/ifNotTrueExecute'
import toastNotification from 'pug/toastNotification'
import { UPDATED_START_FROM_SERVER } from 'messages'
import scrollToError from 'core/DOM/scrollToError'
import { stringToDate, dateToString, propAccessor } from '@hc-frontend/utils'
import getURLParams from 'utils/DOM/getURLParams'
import toggleClass from 'utils/DOM/toggleClass'
import isArray from 'utils/validation/isArray'
import isNumber from 'utils/number/isNumber'
import handleMembers, { addSpouse } from './handleMembers'
import saveToStorage from './saveToStorage'
import innerHTML from 'utils/DOM/innerHTML'
import isEmpty from 'utils/object/isEmpty'
import getById from 'utils/DOM/getById'
import { COMPARE_PLANS, QUOTES } from 'sites/routes'
import permittedRoutes from 'core/constants/permittedRoutes'
import validateRoute from 'utils/validation/validateRoute'
import storage from 'proxy-storage'
import {
  IS_SHORT_TERM,
  IS_AGENT,
  IS_FIXED_BENEFIT_MEDICAL,
  IS_BRIDGE_TO_MEDICARE,
  IS_DENTAL_AND_VISION
} from 'core/constants/environment'
import { BTM, DENTAL_STAND_ALONE, FIXED } from 'core/constants/products'
import getProductsWithCoverageFlag from 'core/DOM/getProductsWithCoverageFlag'
import renderHeaderProducts from 'core/DOM/renderHeaderProducts'
import Templater from '@hc-frontend/shared-assets/src/js/utils/dom/Templater'
import { deepClone, getISODate } from '@hc-frontend/utils'
import { findApplicant } from '@hc-frontend/business'
import { setDOBRules } from 'core/controllers/validations/getErrorToDOB'
import { preventOnCloseEvent } from 'core/services/onClose'
import initSmartly from 'core/initPage/absmartly'
import sendSnowplowClickTrackEvent from '../sendSnowplowClickTrackEvent'
import { validateDOBControllers } from './validateDOBControllers'
import updateMultiCarrierEligibility from 'core/controllerPlans/update-multi-carrier-eligibility'
import store from 'utils/store/withMiddleware'
import getPlans from 'core/controllerPlans/getPlans'
import { getVariant } from 'core/experiment'
import {
  PPI_565_BY_PASS_QUOTE,
  PPI_565_BY_PASS_QUOTE_VARIANTS
} from 'core/constants/experiments'
import formatDate from 'utils/date/format'
import { enableMultiCarrierPlans } from 'utils/experiments'
import sessionHandler from 'core/controllers/sessionHandler'

const headerMenu = getById('header-menu')
const menuTemplate = headerMenu ? Templater(headerMenu.innerText) : undefined

const childOnlyWrap = getById('child-only-wrap')
const controllers = initializerControllers(document.forms.form, handleUpdateLocation)

let lastState
let lastSDate

export function updateProductInformation(product: string | undefined): void {
  toggleClass(document.body, 'fbm', false)

  const isSTM = product === 'stm'

  if (isSTM) {
    toggleClass(childOnlyWrap, 'error', false)
  }

  toggleClass(document.body, 'stm', isSTM)

  setDOBRules(product, childOnlyNode.checked)
  if (controllers.dob.getStatus().value) {
    controllers.dob.validate()
  }

  handleMembers.updateControllerRules(product)
  const hasSelectedProduct = isSTM
  toggleClass('#wrap-period', 'd-none', !hasSelectedProduct)
}

function validateRedirect(urlParams: object): object {
  const { backTo } = urlParams
  const [route, search] = backTo.split('?')
  const validRoute = validateRoute(route, permittedRoutes, permittedRoutes._default)

  if (validRoute !== route || search == null) {
    return { ...urlParams, backTo: validRoute }
  }

  return { ...urlParams, backTo: `${validRoute}?${search}` }
}

function handleDateAfterUpdateLocation(data, hcStorage) {
  if (data.date) {
    const serverStartDate = stringToDate(data.date)
    const sdate = stringToDate(hcStorage.sdate)

    if (sdate && sdate.getTime() < serverStartDate.getTime()) {
      toastNotification(UPDATED_START_FROM_SERVER)
      const newStorage = deepClone(hcStorage)
      newStorage.sdate = dateToString(serverStartDate)
      storage.setItem('hc', newStorage)

      controllers.sdate.updateNextStartDate(newStorage.sdate)
    }
  }
}

async function handlePeriodVisibility(coverageData, period: number) {
  const newPeriod =
    coverageData.coverage &&
    isArray(coverageData.coverage) &&
    coverageData.coverage.includes(period)
      ? period
      : coverageData.longerPeriod

  controllers.period.setValue({ data: coverageData, period: newPeriod })
  innerHTML('.shorterPeriod', coverageData.shorterPeriod === 90 ? 90 : 180)
}

function handleCoverageVisibility(coverageData) {
  if (!IS_SHORT_TERM) {
    return
  }

  const withoutCoverage = isEmpty(coverageData.coverage)
  toggleClass(document.body, 'no-coverage', withoutCoverage)
  toggleClass('#wrap-coverage', 'd-none', withoutCoverage)

  controllers.period.makeOptional(false)
  controllers.period.validate()
}

async function handleUpdateLocation(hcStorage) {
  const sDate = propAccessor(hcStorage, 'sdate')
  const stateAcronym =
    propAccessor(storage.getItem('hc'), 'location.state_acronym') ||
    propAccessor(hcStorage, 'location.state_acronym')

  if (!stateAcronym || !sDate || (lastState === stateAcronym && lastSDate === sDate)) {
    return undefined
  }
  lastState = stateAcronym
  lastSDate = sDate

  if (enableMultiCarrierPlans()) {
    await updateMultiCarrierEligibility(store.getState(), {
      stateAcronym
    })
  }

  const { error, data } = await getCoverageDuration(
    stateAcronym,
    getISODate(new Date(hcStorage.sdate))
  )

  const smartlySDK = initSmartly()

  const disableBTM = smartlySDK ? smartlySDK.treatment('PH_BTM_REDIRECT') : 1

  let products = getProductsWithCoverageFlag({ error, data })

  if (disableBTM) {
    products = products.filter(product => product.name !== 'btm')
  }

  handleCoverageVisibility(data)

  if (menuTemplate) {
    renderHeaderProducts(menuTemplate, products)
  }

  let notCoverage = error
  if (!notCoverage) {
    if (IS_SHORT_TERM) {
      notCoverage = isEmpty(data.coverage)
    }

    if (IS_BRIDGE_TO_MEDICARE) {
      notCoverage = !data.countByProduct[BTM]
    }

    if (IS_DENTAL_AND_VISION) {
      notCoverage = !data.countByProduct[DENTAL_STAND_ALONE]
    }
    if (IS_FIXED_BENEFIT_MEDICAL) {
      notCoverage = !data.countByProduct[FIXED]
    }
  }

  if (controllers.period) {
    handlePeriodVisibility(data, +hcStorage.period)
  }

  if (!IS_SHORT_TERM) {
    toggleClass(document.body, 'no-coverage', notCoverage)
  }
  handleDateAfterUpdateLocation(data, hcStorage)
  renderPlansCount(data.countByProduct)

  window.dataLayer.push({ event: 'PRODUCT_COVERAGES_LOADED_IN_CENSUS' })
}

function updatePeriodToPath(urlParams, period) {
  let path
  const backToUrl = urlParams.backTo
  const backToBase = backToUrl.split('?')[0]
  const backToProps = urlParamsToObject(backToUrl)
  const id = +backToProps['planid']

  if (isNumber(id)) {
    if (IS_BRIDGE_TO_MEDICARE) {
      path = backToUrl
    } else {
      backToProps.period = period
      backToProps.policies = urlParams.policies || 1
      path = `${backToBase}${toUrlParams(backToProps)}`
    }
  } else {
    try {
      path = backToUrl.replace(/^(.*>)(\d+)(-months)$/, `$1${Math.round(period / 30)}$3`)
    } catch (e) {
      path = backToUrl
    }
  }

  return path
}

addEventListener('#form', 'submit', handleSubmit)

const saveSession = sessionHandler({ useState: true, save: true })

async function handleSubmit(e) {
  e.preventDefault()
  let isValidForm = true
  const allControllers = { ...controllers, ...handleMembers.getControllers() }
  const valuesForm = {}

  for (const key in allControllers) {
    const status = allControllers[key].getStatus()

    ifNotTrueExecute(status.valid, allControllers[key].validate)
    isValidForm = isValidForm && status.valid
    valuesForm[key] = status.value
  }

  if (IS_FIXED_BENEFIT_MEDICAL) {
    valuesForm.childOnly = childOnlyNode.checked
  }

  let product = undefined
  let isLongTerm = false
  if (IS_SHORT_TERM) {
    product = 'stm'
    valuesForm.childOnlySMT = childOnlyNode.checked
    isLongTerm = product === 'fbm'
    if (isLongTerm) {
      valuesForm.childOnly = childOnlyNode.checked
    }
  }

  const validateChildOnly = IS_FIXED_BENEFIT_MEDICAL || isLongTerm

  if (validateChildOnly) {
    toggleClass(childOnlyWrap, 'error', valuesForm.childOnly && !valuesForm.dob_1)
    isValidForm = isValidForm && !(valuesForm.childOnly && !valuesForm.dob_1)
  }

  const errors = document.querySelector('.week.error')

  if (!errors && isValidForm) {
    const hcStorage = saveToStorage(valuesForm)
    if (IS_SHORT_TERM) {
      sendSnowplowClickTrackEvent(hcStorage)
    }
    preventOnCloseEvent()

    // So far use the email to decide to force a new session or not
    // More complex logic can be implemented later if needed
    const forceNewSession =
      valuesForm.email &&
      valuesForm.email !==
        propAccessor(store.getState(), 'hcStorage.contact.email_address')

    saveSession(undefined, forceNewSession)
      .then(() =>
        getNewRoute({
          coverageType: valuesForm.coverageType,
          period: valuesForm.period,
          hcStorage: hcStorage
        })
      )
      .then(newRoute => {
        window.location = newRoute
      })
  } else {
    scrollToError()
  }
}

const enableByPass = () =>
  getVariant({
    experimentKey: PPI_565_BY_PASS_QUOTE,
    fallback: PPI_565_BY_PASS_QUOTE_VARIANTS.CONTROL
  }) === PPI_565_BY_PASS_QUOTE_VARIANTS.BYPASS_ENABLE

/** Function to get the url according to the max duration and months selected */
function getUrlParameters() {
  const periodSelector = document.getElementById('containerPeriod')
  const selectedEightMonths = periodSelector.querySelector('input[id="period-8"]:checked')
  const selectedTwelveMonths = periodSelector.querySelector(
    'input[id="period-12"]:checked'
  )
  const durationEight = document.getElementById('period-8')
  const durationTwelve = document.getElementById('period-12')

  let months
  if (selectedEightMonths) {
    months = 8
  } else if (selectedTwelveMonths) {
    months = 12
  } else {
    months = 4
  }

  let duration
  if (durationEight) {
    duration = 8
  } else if (durationTwelve) {
    duration = 12
  } else {
    duration = 4
  }
  return `?months=${months}&maxDuration=${duration}`
}

async function getNewRoute({ coverageType = 'stm', period, hcStorage }) {
  const urlParams = getURLParams()
  const backTo = urlParams.backTo ?? false

  if (IS_SHORT_TERM) {
    if (coverageType === 'fbm') {
      return [`/product/fixed-benefit-medical/quotes`, getFiltersFromUrl()]
        .filter(Boolean)
        .join('?')
    }
  }
  const returnedUrl = backTo
    ? updatePeriodToPath(validateRedirect(urlParams), period)
    : [QUOTES, getFiltersFromUrl()].filter(Boolean).join('?')

  if (enableMultiCarrierPlans() && !IS_DENTAL_AND_VISION) {
    if (enableByPass() && period !== '4') {
      const state = store.getState()
      state.hcStorage = hcStorage
      const quote = await getPlans(state)
      const plans = Object.entries(quote[0].plans).map(entry => entry[1]) as Plan[]
      const multiCarrierPlans = plans.filter((plan: Plan) => plan.multiCarrierPlan) as any
      const planOrders = Object.entries(quote[0].multiCarrierOrder).map(
        order => order[1]
      ) as any
      const defaultPlanId = multiCarrierPlans[0].planId
      const relevantOrder = planOrders.find(order => order.includes(defaultPlanId))
      const plansAggregate = relevantOrder.map(planId =>
        multiCarrierPlans.find(plan => plan.planId === planId)
      )
      let comparePlansRoute = `${COMPARE_PLANS}?plans=`
      plansAggregate.forEach(plan => {
        comparePlansRoute += `${plan.planId}-${plan.durations[0].policyDuration}-1,`
      })
      return comparePlansRoute.slice(0, -1)
    }
    return returnedUrl + getUrlParameters()
  }
  return returnedUrl
}

const optionalInputs = {}

function makeFieldOptional(name) {
  if (!optionalInputs[name]) {
    optionalInputs[name] = false
    const node = document.querySelector(`[for=${name}]`)

    node.innerHTML = node.innerText + ' <small>(optional)</small>'
    controllers[name].makeOptional()
  }
}

// expose global functions to make optional inputs
window.makeEmailOptional = makeFieldOptional.bind(undefined, 'email')
window.makeFirstNameOptional = makeFieldOptional.bind(undefined, 'fname')
window.makeLastNameOptional = makeFieldOptional.bind(undefined, 'lname')

if (IS_AGENT && !isSalesCenterSubDomain()) {
  makeFieldOptional('email')
}
makeFieldOptional('phone')
makeFieldOptional('lname')

const wrapPhone = document.getElementById('wrap-phone')
const wrapLastName = document.getElementById('wrap-lname')

if (isSalesCenterSubDomain()) {
  wrapPhone && toggleClass(wrapPhone, 'd-none', false)
} else {
  if (wrapPhone) {
    toggleClass(wrapPhone, 'd-none', true)
  }
  if (wrapLastName) {
    toggleClass(wrapLastName, 'd-none', true)
  }
}

const childMessage = getById('child-only-message')
const childOnlyNode = getById('child-only')
const applicantDobLabel = document.querySelector('[for="dob"]')
const addSpouseButton = getById('add-spouse')
const spouseWrap = getById('spouse-wrap')

function handleClickOnlyChild(e) {
  const isChildOnly = e.target.checked
  toggleClass(childMessage, 'd-none', !isChildOnly)
  toggleClass(addSpouseButton, 'd-none', isChildOnly)
  toggleClass(spouseWrap, 'd-none', isChildOnly)

  if (IS_SHORT_TERM) {
    const coverageType = 'stm'
    setDOBRules(coverageType, isChildOnly)
    validateDOBControllers({ ...controllers, ...handleMembers.getControllers() })

    toggleClass(document.body, 'child-only', isChildOnly)
    handleMembers.setChildOnlyApplication(isChildOnly)
  }

  applicantDobLabel.innerHTML = `Date of Birth${
    applicantDobLabel && isChildOnly
      ? ' <small class="d-stm-none">(contracting adult)</small>'
      : ''
  }`
}

if (IS_FIXED_BENEFIT_MEDICAL || IS_SHORT_TERM) {
  addEventListener(childOnlyNode, 'change', handleClickOnlyChild)
}

$('body').on('change', '.week input', function (e) {
  toggleClass(
    e.target.parentElement.parentElement.parentElement,
    'error',
    e.target.value !== 'yes'
  )
})

function getProductByPath(backToURL: string): 'stm' | 'fbm' | undefined {
  const fbmProduct = '/product/fixed-benefit-medical'
  const stmProduct = '/product/short-term-health-insurance'

  return backToURL.indexOf(stmProduct) !== -1
    ? 'stm'
    : backToURL.indexOf(fbmProduct) !== -1
    ? 'fbm'
    : undefined
}

async function updateFormData(hcStorage) {
  setValuesFromURL(hcStorage)
  controllers.sdate.setValue(hcStorage.sdate)
  let isChildOnly = false
  controllers.email.setValue(hcStorage.contact.email_address)

  controllers.phone.setValue(hcStorage.contact.phone_home)

  // update members information
  const applicant = findApplicant(hcStorage.members)
  if (applicant) {
    controllers.dob.setValue(applicant.stringDOB)
    if (applicant.dob) {
      controllers.dob.validate()
    }
    controllers.gender.setValue(applicant.gender)
    controllers.fname.setValue(applicant.firstName)
    controllers.lname.setValue(applicant.lastName)
  }
  handleMembers.loadMembers(hcStorage.members)
  isChildOnly = IS_SHORT_TERM ? hcStorage.childOnlySMT : hcStorage.childOnly

  if (IS_SHORT_TERM) {
    const urlParams = getURLParams()

    const backTo = urlParams.backTo || ''
    const coverageType = getProductByPath(backTo)

    if (hcStorage.coverageTypeSelection) {
      controllers.coverageType.setValue(hcStorage.coverageTypeSelection)
      updateProductInformation(hcStorage.coverageTypeSelection)
    } else if (backTo) {
      controllers.coverageType.setValue(coverageType)
    }

    childOnlyNode.checked = isChildOnly
    handleClickOnlyChild({ target: childOnlyNode })
  }

  if (hcStorage.location.zip_code) {
    controllers.zip.setValue(hcStorage)

    await handleUpdateLocation(hcStorage)
  }

  if (IS_FIXED_BENEFIT_MEDICAL) {
    childOnlyNode.checked = isChildOnly
    handleClickOnlyChild({ target: childOnlyNode })
  }

  executeWhenFinishToRender(hcStorage)
}

async function setValuesFromURL(hcStorage) {
  const urlParams = new URLSearchParams(window.location.search)
  const spouse = urlParams.get('spouse')
  if (spouse === 'true') {
    let spouse_gender = urlParams.get('spouse_gender')
    spouse_gender = spouse_gender && spouse_gender.toLowerCase()
    let spouseDob = urlParams.get('spouse_dob')
    spouseDob = formatDate(spouseDob)
    addSpouse({
      gender: spouse_gender,
      stringDOB: spouseDob
    })
  }
  let coverage = urlParams.get('coverage')
  if (coverage) {
    coverage = coverage === 'single' ? '4' : '12'
    const { data } = await getCoverageDuration(
      hcStorage.location.state_acronym,
      getISODate(new Date(hcStorage.sdate))
    )
    controllers.period.setValue({ data: data, period: coverage })
  }

  const zip = urlParams.get('zip')

  if (zip) {
    await controllers.zip.setValue({ location: { zip_code: zip } })
  } else {
    await controllers.zip.setValue({
      location: { zip_code: hcStorage.location.zip_code }
    })
  }
}

export default updateFormData
